import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Typography } from '@carto/meridian-ds/components'
import { TextField } from '@mui/material'
import ConfirmDialog, { ConfirmDialogResult } from 'features/common/ui/ConfirmDialog/ConfirmDialog'
import { IDP } from 'features/integrations/types'

interface SnowflakeConnectionRoleDialogProps {
  open: boolean
  onConfirm: (role?: string) => void
  onCancel: () => void
  idpType?: IDP
}

function SnowflakeConnectionRoleDialog({ open, onConfirm, onCancel, idpType }: SnowflakeConnectionRoleDialogProps) {
  const intl = useIntl()
  const [role, setRole] = useState<string>('')
  const isExternalOAuth = idpType && idpType !== IDP.SNOWFLAKE
  const isRoleRequired = !isExternalOAuth

  const handleResult = (result: ConfirmDialogResult) => {
    result === ConfirmDialogResult.Confirm ? onConfirm(role) : onCancel()
  }
  return (
    <ConfirmDialog
      open={open}
      title={<FormattedMessage id="connections.create.snowflake.roleDialog.title" />}
      onResult={handleResult}
      confirmLabel={<FormattedMessage id="common.button.continue" />}
      showCancelButton={false}
      confirmButtonProps={{
        disabled: isRoleRequired && !role.trim()
      }}
    >
      <Typography variant="body2" color="textSecondary">
        <FormattedMessage
          id={
            isExternalOAuth
              ? 'connections.create.snowflake.roleDialog.descriptionExternalOAuth'
              : 'connections.create.snowflake.roleDialog.descriptionSnowflakeOAuth'
          }
        />
      </Typography>
      <TextField
        label={intl.formatMessage({ id: 'connections.create.snowflake.form.roleLabel' })}
        value={role}
        onChange={(e) => setRole(e.target.value)}
        required={isRoleRequired}
      />
    </ConfirmDialog>
  )
}

export default SnowflakeConnectionRoleDialog
